import { render, staticRenderFns } from "./PostingsMultiselect.vue?vue&type=template&id=1a571fcb"
import script from "./PostingsMultiselect.vue?vue&type=script&lang=ts"
export * from "./PostingsMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a571fcb')) {
      api.createRecord('1a571fcb', component.options)
    } else {
      api.reload('1a571fcb', component.options)
    }
    module.hot.accept("./PostingsMultiselect.vue?vue&type=template&id=1a571fcb", function () {
      api.rerender('1a571fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/PostingsMultiselect.vue"
export default component.exports